export default "/images/finish_setup_placeholder.webp"